import { InstagramListUrlSortField } from "@saleor/instagram/urls";
import { InstagramSortFidls } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: InstagramListUrlSortField
): InstagramSortFidls {
  switch (sort) {
    case InstagramListUrlSortField.name:
      return InstagramSortFidls.USERNAME;
    case InstagramListUrlSortField.image:
      return InstagramSortFidls.IMAGE;
    case InstagramListUrlSortField.instagramid:
      return InstagramSortFidls.INSTAGRAM_ID;
    case InstagramListUrlSortField.createTime:
      return InstagramSortFidls.CREATE_TIME;
    case InstagramListUrlSortField.shortcode:
      return InstagramSortFidls.SHORTCODE;
    default:
      return undefined;
  }
}
export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
